import {StyleSheet} from 'react-native';

import {default as SkillzStyle} from 'SkillzStyle';

const {fontRegular, fontExtraBold, textColorTicketz, fontBold, fontMedium} = SkillzStyle.fullStyles;

export const styles = StyleSheet.create({
  mainContainer: {
    flex: 1,
    backgroundColor: '#FAFAFA',
  },
  screenContentContainer: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    padding: 14,
  },
  userInfoContainer: {
    paddingTop: 20,
  },
  accountInfoIcon: {
    width: 70,
    height: 73,
    alignSelf: 'center',
    marginBottom: 16,
  },
  formTitle: {
    fontSize: 20,
    textAlign: 'center',
    marginBottom: 8,
    color: '#333',
    letterSpacing: -0.6,
    ...fontExtraBold,
  },
  subTitle: {
    textAlign: 'center',
    marginBottom: 16,
    fontSize: 13,
    color: '#3A3A3A',
    letterSpacing: -0.13,
    ...fontRegular,
  },

  inputContainer: {
    marginBottom: 8,
  },

  lockableInputContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 8,
  },

  lockIcon: {
    width: 20,
    height: 20,
    position: 'absolute',
    right: 10,
    zIndex: 1000,
  },

  inputStyle: {
    paddingVertical: 15,
    paddingHorizontal: 11,
    backgroundColor: '#fff',
    borderColor: '#797979',
    borderWidth: 1,
    borderRadius: 3,
    fontSize: 16,
    fontWeight: '400',
    lineHeight: 18,
    color: '#333',
    width: '100%',
  },
  inputStyleDisabled: {
    paddingVertical: 15,
    paddingHorizontal: 11,
    backgroundColor: '#F2F1F1',
    borderColor: '#797979',
    borderWidth: 1,
    borderRadius: 3,
    fontSize: 16,
    color: '#797979',
    width: '100%',
  },

  inputStyleFocused: {
    borderColor: '#367BCE',
  },

  inputStyleError: {
    borderColor: textColorTicketz.color,
  },

  inputError: {
    ...textColorTicketz,
    ...fontBold,
    fontSize: 12,
  },
  aeropayIcon: {
    width: 139,
    height: 50,
    alignSelf: 'center',
    marginTop: 5,
    marginBottom: 40,
  },
  secureIcon: {
    width: '100%',
    height: 115,
    alignSelf: 'center',
  },

  buttonContainer: {
    paddingHorizontal: 14,
    bottom: 16,
  },

  shieldIcon: {
    width: 17,
    height: 19,
    flexShrink: 0,
  },

  // PUSH BUTTON STYLES
  submitText: {
    letterSpacing: -0.54,
    color: '#FFFFFF',
    fontSize: 18,
    ...fontExtraBold,
  },

  submitButton: {
    marginTop: 10,
    height: 45,
  },
});

export const inputStyleFocused = {...styles.inputStyle, ...styles.inputStyleFocused};
export const inputStyleError = {...styles.inputStyle, ...styles.inputStyleError};

export const emailInputStyle = (inputFocused: string, emailError: boolean) => {
  return inputFocused === 'email' && !emailError
    ? inputStyleFocused
    : emailError
      ? inputStyleError
      : styles.inputStyle;
};
